import posthog from "posthog-js";
import * as Sentry from "@sentry/react";
import type { AnalyticsConfig } from "./types";

let posthogReady = false;

export function isPosthogReady() {
  return posthogReady;
}

export function initAnalytics(config: AnalyticsConfig) {
  if (config.posthog?.key) {
    posthogReady = true;
    posthog.init(config.posthog.key, {
      api_host: config.posthog.host,
      person_profiles: "identified_only",
      capture_pageview: false,
      capture_pageleave: true,
      session_recording: config.posthog.sessionRecording
        ? { maskAllInputs: true }
        : undefined,
      disable_session_recording: !config.posthog.sessionRecording,
    });
  }

  if (config.sentry?.dsn) {
    Sentry.init({
      dsn: config.sentry.dsn,
      environment: config.sentry.environment,
      release: config.sentry.release,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: config.sentry.tracesSampleRate ?? 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    Sentry.setTag("app", config.appName);
  }
}
